module.exports = __webpack_public_path__ + "static/media/topic_user2.202ffcbb.png";